import { QRCode } from "react-qrcode-logo";
import { Flex } from "@paguelofacil/pf-components";

import { DEEP_LINK_QR_RECHARGE_APP } from "../../services/utils/Constants";
import { formattedDeeplink } from "../../utils/helpers";

export const PayWithQr = ({ amountToRecharge }) => {
    return (
        <Flex justify="center">
            <QRCode
                ecLevel="L"
                eyeRadius={10}
                qrStyle="dots"
                logoImage="https://assets.paguelofacil.com/checkout/new_bills.webp"
                logoWidth={40}
                value={formattedDeeplink(DEEP_LINK_QR_RECHARGE_APP, { amount: amountToRecharge, flow: "crypto" })}
                quietZone={20}
                size={200}
            />
        </Flex>
    );
};
